export enum UserStatusOptions {
  waitingForWelcomeEmail = 'waitingForWelcomeEmail',
  // the user has never logged in and was created by a sales rep
  salesNeverLoggedIn = 'salesNeverLoggedIn',
  passwordEmailNotSent = 'passwordEmailNotSent',
}

export const UserStatusOptionsArray = [
  'waitingForWelcomeEmail',
  'salesNeverLoggedIn',
  'passwordEmailNotSent',
];
